import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {withModal} from 'src/services/ModalService';
import {ErrorModal as _ErrorModal} from "src/components/modals/error/Error";

class ErrorModal extends Component {
    render () {
        const { modals, hideModal } = this.props;
        const { options } = modals;

        return ReactDOM.createPortal(
            <_ErrorModal
                show
                onClose={hideModal}
                title={options.title}
                children={options.children}
            />,
            document.getElementById('modals-content')
        );
    }
}

export default withModal(ErrorModal);
